export const factorsOverview = {
  en: 'Outcome factors represents a framework that connects personality traits, competencies and abilities to specific organisational goals – productivity, burnout and turnover intention. These work as a predictive tool, based on research showing how various characteristics can increase the likelihood of achieving specific organisational outcomes.',
  nb: 'Utfallsvariabler representerer et rammeverk som kobler personlighetstrekk, kompetanser og evner til spesifikke organisatoriske mål - produktivitet, utmattelse og intensjon om jobbskifte. Disse fungerer som et prediktivt verktøy, basert på forskning som viser hvordan ulike egenskaper kan øke sannsynligheten for å oppnå bestemte organisatoriske utfall.',
}

export const factors = [
  {
    key: 'Productivity',
    isHighGood: true,
    description: {
      en: 'The relationship between what an organisation produces and the resources used to achieve this.',
      nb: 'Forholdet mellom det en organisasjon produserer, og ressursene som brukes for å oppnå dette.',
    },
  },
  {
    key: 'Burnout',
    isHighGood: false,
    description: {
      en: 'The level of physical, emotional, or mental strain that impacts the ability to maintain performance over time.',
      nb: 'Graden av fysisk, emosjonell eller mental belastning som påvirker evnen til å opprettholde prestasjon over tid.',
    },
  },
  {
    key: 'Turnover Intention',
    isHighGood: false,
    description: {
      en: 'The tendency to be satisfied with their current situation rather than leaving or seeking new opportunities.',
      nb: 'Tendensen til å være tilfreds i nåværende situasjon, fremfor å avslutte eller søke nye muligheter. ',
    },
  },
]
